import React from 'react';
import {executeQuery} from "../../requests/executeQuery";
import {STRIVE_FEES} from "../../consts/queries";
import {FeesPipeline} from "./FeesPipeline";
import dollars, {dollarsOrZero} from "../../dollar-format";
import {columns, printFirstColumns, printSecondColumns} from "./columns";
import Input from "../Input";
import transactionTypes from "../../transaction-types";
import {Chip, TextField} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import SelectTeam from "../SelectTeam-new/SelectTeam";
import filter from "../../filter";
import {calculateTotalColumn, formatName, getNotEmptyValueCount, renderPrintFooter} from "../../utils";
import {getData} from "../../requests/CRUD";
import {Link} from "react-router";
import {TEAM} from "../../consts/tables";
import propertyCategories from '../../property-categories';
import propertySide, { STRIVE_ARCIMEDES_ROW_ID } from '../../property-side';
import propertyTypes from '../../property-types';
import cloneDeep from 'lodash.clonedeep';

const noPropertiesPerPage = 12;

export default class SummitFees extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: [],
            query: {
                SOURCE: 'SUMMIT,External',
                START_DATE: `01/01/${new Date().getFullYear()}`,
                END_DATE: new Date().toLocaleDateString('en-US'),
                // Extra Payment is excluded by default so the header count matches
                // the Closings - YTD stat card, which doesn't count an Extra Payment
                // as a closing of its own; it stays selectable in the filter.
                TRANSACTION_TYPE: 'Investment Sales,Leasing,Financing,Advisory,Referral',
                AGENT_ID: '',
                order: 'CLOSE_OF_ESCROW.asc',
                CATEGORY: null,
                TYPE: null,
                SIDE: 'ALL'
            },
            agentName: '',
            isPrint: false,
            printBackground: '',
        };

        this.getValuesForDropdown = this.getValuesForDropdown.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
        this.handleSideChangeDropdown = this.handleSideChangeDropdown.bind(this);
        this.getSideValuesForDropdown = this.getSideValuesForDropdown.bind(this);
        this.handleAgentChange = this.handleAgentChange.bind(this);
    }

    componentDidMount() {
        this.setState({printBackground: `url('${arc.path.media + 'Transaction_Background.png'}')`}, this.fetch);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    fetch() {
        let query = cloneDeep(this.state.query);
        query = filter(query, 'striveFees');
        const agentOptions = {
            limit: {
                count: 1,
                offset: 0,
            },
            column: [
                'FIRST_NAME',
                'LAST_NAME',
            ],
            filter: [{
                code: 'ARCIMEDES_ROW_ID',
                text: this.state.query.AGENT_ID,
                type: 'exact',
            }],
        };

        const selectedAgentIds = (this.state.query.AGENT_ID || '').split(',').filter(Boolean);
        const side = this.state.query.SIDE;

        Promise.all([
            executeQuery({queryName: STRIVE_FEES, options: query}),
            getData({tableCode: TEAM, options: agentOptions})
        ]).then(res => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data)) {
                const rows = res[0].data.map((data, index) => {
                    return new FeesPipeline(data, index + 1, false, selectedAgentIds, false, side)
                });
                if(rows.length>0){
                    const striveFee = calculateTotalColumn(rows, 'striveFee');
                    const no_non_empty_transactions = getNotEmptyValueCount(rows, "striveFee");
                    // With an agent filter, an in-house slot's total counts only
                    // the deals where that slot is occupied by a selected agent,
                    // so a co-agent's split on a shared deal never lands in the
                    // filtered totals. The Outside Agent totals stay full sums:
                    // the selected agent is never the outside agent.
                    const slotTotal = (priceKey, idKey) => selectedAgentIds.length
                        ? rows.reduce((sum, row) => sum + (selectedAgentIds.includes(row[idKey]) && row[priceKey] ? row[priceKey] : 0), 0)
                        : calculateTotalColumn(rows, priceKey);
                    rows[rows.length] = new FeesPipeline({
                        TOTAL_FEE: calculateTotalColumn(rows, 'totalFee'),
                        STRIVE_FEE: striveFee,
                        AGENT_FEE: calculateTotalColumn(rows, 'agentFee'),
                        LISTING_AGENT1_TOTAL_FEE: slotTotal('listingAgent1Price', 'listingAgent1Id'),
                        LISTING_AGENT2_TOTAL_FEE: slotTotal('listingAgent2Price', 'listingAgent2Id'),
                        LISTING_AGENT3_TOTAL_FEE: slotTotal('listingAgent3Price', 'listingAgent3Id'),
                        LISTING_AGENT4_TOTAL_FEE: calculateTotalColumn(rows, 'listingAgent4Price'),
                        BUYER_AGENT1_TOTAL_FEE: slotTotal('buyerAgent1Price', 'buyerAgent1Id'),
                        BUYER_AGENT2_TOTAL_FEE: slotTotal('buyerAgent2Price', 'buyerAgent2Id'),
                        BUYER_AGENT3_TOTAL_FEE: slotTotal('buyerAgent3Price', 'buyerAgent3Id'),
                        BUYER_AGENT4_TOTAL_FEE: calculateTotalColumn(rows, 'buyerAgent4Price'),
                        TRANSACTION_TYPE: "Total:"
                    }, null, true, [], false);
                    rows[rows.length] = new FeesPipeline({
                        NO_OF_TRANSACTIONS: res[0].data.length,
                        TRANSACTION_TYPE: "# of Trans:"
                    }, null, false, [], true);

                    rows[rows.length] = new FeesPipeline({
                        STRIVE_FEE: striveFee,
                        NO_OF_TRANSACTIONS: no_non_empty_transactions,
                        TRANSACTION_TYPE: "Ave/Tran:"
                    }, null, false, [], true);
                }
                const state = {
                    rows,
                };
                if(res[1] && res[1].success && Array.isArray(res[1].data) && res[1].data.length) {
                    state.agentName = formatName(res[1].data[0]);
                }//to remove the selected AgentName if we click on the unselect(X) button
                else if(res[1] && !res[1].success){
                    state.agentName = ''
                }
                this.setState(state);
            }
        });
    }

    getValuesForDropdown(query, options, key, type = 'multiple') {

        if (!query || !options || !options.length) return [];

        let formattedQueryValues = query.split(',');
        let response = [];

        options.forEach((el) => {
            if (!key) {
                if (formattedQueryValues.includes(el))
                    response.push(el);
            } else {
                if (formattedQueryValues.includes(el[key]))
                    response.push(el);
            }
        });

        if (!response) return [];
        if (type === "multiple") return response;
        return response[0];
    }

    handleChangeDropdown(event, reason, queryType, dropdownType = 'single', key = null) {
        const query = {...this.state.query};

        if (!reason) {
            query[queryType] = null;
        } else {
            if (dropdownType === 'single') {
                if (!key)
                    query[queryType] = reason;
                else
                    query[queryType] = reason[key];
            } else {
                let result = '';
                reason.forEach(el => {
                    if (!key)
                        result += el + ',';
                    else
                        result += el[key] + ',';
                });
                if((queryType === "AGENT_ID" && result.split(",").length<=5) || queryType !== "AGENT_ID"){
                    query[queryType] = result;
                }
            }
        }
        this.setState({query});
    }

    getSideValuesForDropdown() {
        const {SIDE} = this.state.query
        if( SIDE == 'ALL'){
            return null
        }else if(SIDE == 'LISTING_AGENT_4_FIRM'){
            return propertySide[0]
        }else if(SIDE == 'BUYER_AGENT_4_FIRM'){
            return propertySide[1]
        }
    }

    handleSideChangeDropdown(e, value){
        const query = {...this.state.query};
        if(value == null){
            query.SIDE = 'ALL'
        }else if(value.code === "listside"){
            query.SIDE = 'LISTING_AGENT_4_FIRM'
        }else if(value.code === "buyside"){
            query.SIDE = 'BUYER_AGENT_4_FIRM'
        }
        this.setState({query});
    }
    handleChange(e) {
        const query = {...this.state.query};
        query[e.currentTarget.name] = e.currentTarget.value;
        this.setState({query});
    }

    // Dropdown hands back its data object with AGENT_ID set to a comma list of
    // TEAM ids (or removed on clear).
    handleAgentChange(data) {
        const ids = ((data && data.AGENT_ID) || '').split(',').filter(Boolean);
        if (ids.length > 4) return; // the fees query accepts at most 4 agents
        const query = {...this.state.query};
        query.AGENT_ID = ids.join(',');
        this.setState({query});
    }

    onSubmit() {
        this.fetch();
    }

    static renderCell({row, index, column, isCustom=false}) {
        // The "# of Trans:" row shows a raw count in a money column, and the
        // "Ave/Tran:" row only fills the cells it owns — everywhere else a
        // money cell always renders a value, $0.00 included.
        const isCountRow = row['transactionType'] === "# of Trans:";
        const isAverageRow = row['transactionType'] === "Ave/Tran:";

        // An agent slot nobody is assigned to renders a blank amount, not
        // $0.00; an assigned agent whose commission is genuinely zero keeps
        // the $0.00. A cell that holds money is never blanked, even when the
        // slot's name could not be resolved. Footer rows keep their sums.
        const slotKey = column.key.replace(/(Price|Percent)$/, '');
        const isEmptySlotCell = slotKey !== column.key
            && /^(listing|buyer)Agent[1-4]$/.test(slotKey)
            && !isCustom
            && !row[slotKey]
            && !row[column.key];

        let value = '';
        if (column.format === '$' && !isCountRow && !isEmptySlotCell && !(isAverageRow && !row[column.key])) {
            value = dollarsOrZero(row[column.key], column.withCents);
        } else if (row[column.key]) {
            if (column.format === '%') {
                value = `${row[column.key].toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
            } else {
                value = row[column.key];
            }
        }

        const title = ['name', 'city'].includes(column.key) && value ? value : undefined;

        return (
            <td key={index+'-'+column.key}
                title={title}
                className={`${isCustom ? 'Fees_footer' : 'Fees_td'} ${column.class ? column.class : ''}`}>
                {
                    column.key === 'name' ?
                        <Link to={{ pathname: '/property/' + row.id }}>
                            {value}
                        </Link>
                        : column.key === "transactionType" ?
                            <React.Fragment>{value == "Investment Sales" ? value = "Sale" : isCustom ? value:"Ref"}</React.Fragment>
                            : <React.Fragment>{value}</React.Fragment>
                }
            </td>
        );
    }

    renderTable(columns, rows, className, isLastTable = null) {
        const hasSubColumns = true;
        const lastIndex = isLastTable || isLastTable === null ? [rows.length - 1, rows.length - 2, rows.length - 3] : [];
        return (
            <table className={className}>
                <thead>
                <tr>
                    {
                        columns.map((column, index) => {
                            const subColsNo = column.subColumns ? column.subColumns.length : 1;
                            return (
                                <th key={index}
                                    className={`Fees_th ${column.subColumns ? 'has-subcolumn' : ''}`}
                                    rowSpan={column.subColumns ? 1 : 2}
                                    colSpan={column.subColumns ? subColsNo : 1}>
                                    {column.name}
                                    {column.subName && <span><br/> {column.subName}</span>}
                                </th>
                            )
                        })
                    }
                </tr>
                {
                    hasSubColumns ?
                        <tr>
                            {
                                columns.map((column, index) => {
                                    if (column.subColumns) {
                                        return column.subColumns.map((subColumn, subColIndex) => {
                                            return (
                                                <th key={index+subColIndex}
                                                    className="Fees_th subcolumn">{subColumn.name}
                                                </th>
                                            )
                                        });
                                    }
                                })
                            }
                        </tr>
                        :
                        null
                }
                </thead>
                <tbody>
                {
                    rows.map((row, index) => {
                        return (
                            <tr key={index}>
                                {
                                    columns.map(column => {
                                        if (column.subColumns) {
                                            return column.subColumns.map(subCol => {
                                                return SummitFees.renderCell({row, index, column: subCol, isCustom: lastIndex.includes(index)});
                                            });
                                        }
                                        return SummitFees.renderCell({row, index, column, isCustom: lastIndex.includes(index)});
                                    })
                                }
                            </tr>
                        );
                    })
                }
                </tbody>
            </table>
        );
    }

    renderPrintPages({rows, startDate, date, propertyNo, agentName, isPrint, printBackground}) {
        let pageIndex = 0;
        const noTables = Math.ceil(rows.length / noPropertiesPerPage);

        return (
            [...Array(noTables)].map((value, index) => {
                const isLastTable = noTables === index + 1;
                const properties = rows.slice(pageIndex, pageIndex + noPropertiesPerPage);
                pageIndex += noPropertiesPerPage;

                return [printFirstColumns, printSecondColumns].map((cols, colsIndex) => {
                    return (
                        <div className='print-container'
                             key={`${index}-${colsIndex}`}
                             style={{backgroundImage: isPrint && printBackground}}>
                            <div className='Fees_head_left' style={{marginBottom: 20}}>
                                <h4 className='Fees_h3'>SUMMIT Fees</h4>
                                <h4 className='Fees_h4'>{startDate} - {date}</h4>
                                {/* <h4 className='Fees_h4'>{agentName ? agentName : 'SUMMIT'}</h4> */}
                                <h4 className='Fees_h4'>SUMMIT</h4>
                                <h4 className='Fees_h4'>{propertyNo} Properties Closed</h4>
                            </div>
                            {this.renderTable(cols, properties, null, isLastTable)}
                            {renderPrintFooter(isPrint)}
                        </div>
                    );
                });
            })
        );
    }

    render() {
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();
        const {rows, query, agentName, isPrint, printBackground} = this.state;
        const propertyNo = calculateTotalColumn(rows, null, true) - 3;  // without the total/avg row
        const startDate = query.START_DATE;
        return (
            <div className='Fees'>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
                {/* {this.renderPrintPages({columns, rows, date, propertyNo, agentName, isPrint, printBackground})} */}
                {this.renderPrintPages({ columns, rows, startDate, date, propertyNo, agentName, isPrint, printBackground })}

                <div className='Fees_head'>
                    <div className='Fees_head_left'>
                        <h4 className='Fees_h3'>SUMMIT Fees</h4>
                        <h4 className='Fees_h4'>{query.START_DATE} - {query.END_DATE}</h4>
                        {/* <h4 className='Fees_h5'>{agentName ? agentName : 'SUMMIT'}</h4> */}
                        <h4 className='Fees_h4'>SUMMIT</h4>
                        <h4 className='Fees_h5'>{propertyNo >0 ? propertyNo : 0} Properties Closed</h4>
                        <button className='Fees_apply' onClick={this.onSubmit}>Apply</button>
                    </div>                   
                    <div className='Fees_head_right'>
                        <Input name='START_DATE'
                               value={query.START_DATE}
                               label='Start Date'
                               onChange={this.handleChange}
                               placeholder='MM/DD/YYYY'
                               pattern='(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]([1|2]\d\d\d)'
                        />
                        <Input
                            name='END_DATE'
                            value={query.END_DATE}
                            label='End date'
                            onChange={this.handleChange}
                            placeholder='MM/DD/YYYY'
                            pattern='(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]([1|2]\d\d\d)'
                        />
                        <Autocomplete
                            className='white-old single-select'
                            fullWidth	style={{marginBottom: '10px'}}
                            getOptionLabel={(option) => {
                                let result = '';
                                if (option && option.length !== 0) {
                                    result = option.name;
                                }
                                return result;
                            }}
                            options={propertyCategories}
                            value={this.getValuesForDropdown(query.CATEGORY, propertyCategories, 'code', 'single')}
                            renderInput={(params) => <TextField {...params} label='Category' variant="outlined" />}
                            onChange={(event, reason) => {this.handleChangeDropdown(event, reason, 'CATEGORY', 'single', 'code')}}
                        />
                        <Autocomplete
                            className='white-old single-select'
                            fullWidth	style={{marginBottom: '10px'}}
                            getOptionLabel={(option) => {
                                let result = '';
                                if (option && option.length !== 0) {
                                    result = option.name;
                                }
                                return result;
                            }}
                            options={propertyTypes}
                            value={this.getValuesForDropdown(query.TYPE, propertyTypes, 'code', 'single')}
                            renderInput={(params) => <TextField {...params} label='Type' variant="outlined" />}
                            onChange={(event, reason) => {this.handleChangeDropdown(event, reason, 'TYPE', 'single', 'code')}}
                        />
                        <Autocomplete
                            className='white-old single-select'
                            fullWidth	style={{marginBottom: '10px'}}
                            getOptionLabel={(option) => {
                                let result = '';
                                if (option && option.length !== 0) {
                                    result = option.name;
                                }
                                return result;
                            }}
                            options={propertySide}
                            value={this.getSideValuesForDropdown()}
                            renderInput={(params) => <TextField {...params} label='Side' variant="outlined" />}
                            onChange={(event, reason) => {this.handleSideChangeDropdown(event, reason)}}
                        />
                        <SelectTeam theme='white-old agent'
                                    valueKey='AGENT_ID'
                                    value={query.AGENT_ID}
                                    data={{AGENT_ID: query.AGENT_ID}}
                                    isFilter={true}
                                    handleParentChange={this.handleAgentChange}
                                    label='AGENT'
                                    dropdownType={'multiple'}
                                    onlySummitAgents
                                    sortByFirstName
                        />
                        <Autocomplete
                            multiple className={'white-old transaction-type'}
                            options={transactionTypes}
                            value={this.getValuesForDropdown(query.TRANSACTION_TYPE, transactionTypes, null, 'multiple')}
                            renderInput={(params) => <TextField {...params} label="Transaction Type" variant="outlined"/>}
                            renderTags={(tagValue, getTagProps) =>
                                tagValue.map((option, index) =>
                                    <Chip key={index} {...getTagProps({index})} label={option[0]}/>
                            )}
                            onChange={(event, reason) => this.handleChangeDropdown(event, reason, 'TRANSACTION_TYPE', 'multiple')}
                        />
                        
                    </div>
                </div>
                <div className='Fees_table-scroll'>
                    {this.renderTable(columns, rows, 'screen-table')}
                </div>
            </div>
        )
    }
}